import { useEffect, useRef } from 'react';

// https://benestudio.co/guide-to-access-previous-props-or-state-in-react-hooks/
export function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
